import { render, staticRenderFns } from "./click2moneyOffers.vue?vue&type=template&id=5a36a1c6&"
import script from "./click2moneyOffers.vue?vue&type=script&lang=js&"
export * from "./click2moneyOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports